import {
  IAbstractCommentConfiguration,
  ICommentConfiguration,
  IViafouraCommentConfiguration
} from "@webng-types/write-model";

/**
 * The per-post conversation configuration is polymorphic by provider. `Event.comments`
 * is typed as the abstract base, so every consumer that needs provider-specific fields
 * (or provider-specific behaviour) must narrow first.
 *
 * These guards live here rather than in `@webng/liveblog` because `editor-backend` is a
 * Lambda and cannot depend on a React package.
 */

export function isNativeCommentConfiguration(
  comments: IAbstractCommentConfiguration | undefined
): comments is ICommentConfiguration {
  return comments?._type === "Tik::Model::Content::CommentConfiguration";
}

export function isViafouraCommentConfiguration(
  comments: IAbstractCommentConfiguration | undefined
): comments is IViafouraCommentConfiguration {
  return comments?._type === "Tik::Model::Content::ViafouraCommentConfiguration";
}
